import { styled, css } from 'styled-components';
export const OptionWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 20px 10px 16px;
  gap: 10px;
  width: 100%;
  background: ${({ theme }) => theme.colors.grey00_6};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.grey05_1};
  }

  ${({ $isFocused, theme }) => $isFocused &&
    css `
      background: ${theme.colors.grey05_1};
    `}
`;
export const Label = styled.div `
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
`;
